<!-- <div *ngIf="mensajes.length > 0" class='notification-container'> -->
<div class='notification-container'>
    <ul>
        <li *ngFor="let mensaje of mensajes" class="{{mensaje.tipo}} notificacion" [innerHtml]="mensaje.texto">
        </li>
    </ul>
</div>
